.timeEndedHeader {
  padding: 16px;
  background: linear-gradient(135deg, var(--color-active-1), var(--color-active-3));
  color: white;
  font-size: 20px;
}
